import React from "react";
import Shell from "../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DTOActionRequired from "./DTOActionRequired";
import ActionRequiredPresenter from "./ActionRequiredPresenter";

function ActionRequiredController() {
  return (
    <>
      <DTOActionRequired />
      <Shell>
        <Grid
          container
          style={{
            maxWidth: "auto",
            marginLeft: "7.25em",
          }}
        >
          {" "}
          <ActionRequiredPresenter />
        </Grid>
      </Shell>
    </>
  );
}
export default ActionRequiredController;
